import AddIcon from "@mui/icons-material/Add";
import {
  Button,
  Card,
  CardContent,
  CardHeader,
  Chip,
  Grid,
} from "@mui/material";
import { useEffect, useState } from "react";
import ContractorEquipmentCatalogApi from "../../../../../infrastructure/api/contractorEquipmentCatalog";
import BreadcrumbsComponent from "../../../../components/shared/breadcrumbs";
import EnhancedTable from "../../../../components/shared/table";
import NewEquipmentItemRequestDialog from "../../shared/equipmentCatalog/NewEquipmentItemRequestDialog";

const ContractorEquipmentItemRequestsPage = () => {
  const [rows, setRows] = useState([]);
  const [requestOpen, setRequestOpen] = useState(false);

  const load = () =>
    ContractorEquipmentCatalogApi.getMyItemRequests().then((r) =>
      setRows(r?.data || [])
    );

  useEffect(() => {
    load();
  }, []);

  const headCells = [
    { id: "categoryTitle", label: "دسته" },
    { id: "brandText", label: "برند" },
    { id: "modelText", label: "مدل" },
    {
      id: "statusTitle",
      label: "وضعیت",
      render: (value) => <Chip size="small" label={value || "—"} />,
    },
    { id: "reviewNote", label: "یادداشت بررسی" },
    { id: "createOn", label: "تاریخ", type: "date" },
  ];

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <BreadcrumbsComponent />
      </Grid>
      <Grid item xs={12}>
        <Card>
          <CardHeader
            title="درخواست‌های افزودن تجهیز به کاتالوگ مرجع"
            subheader="اگر تجهیز موردنظر در کاتالوگ نیست، از اینجا پیشنهاد دهید تا پس از تأیید مدیریت قابل انتخاب باشد."
            action={
              <Button
                variant="contained"
                startIcon={<AddIcon />}
                onClick={() => setRequestOpen(true)}
              >
                درخواست تجهیز جدید
              </Button>
            }
          />
          <CardContent>
            <EnhancedTable
              rowKey="id"
              rows={rows}
              headCells={headCells}
              pageSize={50}
            />
          </CardContent>
        </Card>
      </Grid>

      <NewEquipmentItemRequestDialog
        open={requestOpen}
        onClose={() => setRequestOpen(false)}
        onSubmitted={() => load()}
        submitRequest={ContractorEquipmentCatalogApi.submitNewEquipmentRequest}
      />
    </Grid>
  );
};

export default ContractorEquipmentItemRequestsPage;
